import { Component, Input, OnInit } from '@angular/core';
import { CustomerMsisdnNotificationPaginatorInterface } from '../../models/customer-msisdn-notification-paginator.interface';
import { select, Store } from '@ngrx/store';
import {
  GetCustomerNotifications,
  GetMsisdnNotifications
} from '../../store/actions/customer-msisdn-notifications.actions';
import { LineInterface } from '../../../lines/models/line.interface';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { MsisdnNotificationsInterfaceState } from '../../store/state/msisdn-notifications.state';
import { UpdatePaginator } from '../../store/actions/paginator.actions';
import { PaginatorInterface } from '../../models/paginator.interface';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css'],
  standalone: false
})
export class NotificationsComponent implements OnInit {

  @Input()
  type?: string = null;

  @Input()
  selectedLine?: LineInterface = null;

  @Input()
  notificationsPaginator: CustomerMsisdnNotificationPaginatorInterface;

  constructor(private store: Store<any>, private sanitizer: DomSanitizer) {}


  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER_MSISDN_NOTIFICATIONS)).subscribe((response: MsisdnNotificationsInterfaceState) => {
      if (response.result != null) {
        this.notificationsPaginator = response.result;
        const paginator = this.getPaginator();
        paginator.type = this.type;
        this.store.dispatch(new UpdatePaginator(paginator));
      }
    });

    const paginator = this.getPaginator();
    paginator.type = this.type;
    this.store.dispatch(new UpdatePaginator(paginator));
  }

  displayMessage(text: string) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  private getPaginator() {
    const paginator = {
      currentSelectedPage: this.notificationsPaginator.currentPage,
      selectedLine: null,
      action: null,
      totalItems: this.notificationsPaginator.totalItems,
      type: null,
    } as PaginatorInterface;
    switch (this.type) {
      case 'msisdn':
        paginator.action = GetMsisdnNotifications;
        paginator.selectedLine = {
          phoneNumber: this.selectedLine.phoneNumber,
          offerLabel: this.selectedLine.offer.labelTunnel,
          offerId: this.selectedLine.offer.id,
          offerGt: this.selectedLine.offer.offerGt,
          status: this.selectedLine.status,
          retractionDate: ['', null, undefined].indexOf(this.selectedLine.retractionDate) === -1 ? this.selectedLine.retractionDate : null,
          billEndDate: this.selectedLine.billEndDate
        };
        break;
      default:
        paginator.selectedLine = null;
        paginator.action = GetCustomerNotifications;
    }

    return paginator;
  }
}
